<template>
  <div>
    <van-dialog v-if="false" v-model="showDialog" :show-confirm-button="false" class="custom-media-dialog-width custom-media-dialog">
<!--      @touchstart="handleTouchStart"-->
<!--      @touchmove="handleTouchMove"-->
<!--      @touchend="handleTouchEnd"-->
      <div class="media-main">
        <div class="dialog_title_dark hx-flex-c-c hx-flex-j-b">
          <van-icon name="cross" @click="closeIconClick" size="26px" />

          <div class="title_content">
           {{currentMediaIndex + 1}} / {{mediaList.length}}
          </div>
        </div>

<!--        <div class="one-line" v-show="mediaList[currentMediaIndex].mediaType === 'video'">
          <video ref="videoPlayer" width="100%"
                 controls
                 preload="auto"
                 webkit-playsinline
                 x5-playsinline
                 :poster="mediaList[1].mediaSrc"
                 :src="mediaList[currentMediaIndex].mediaSrc"
                 @play="onProductVideoPlay"
          >
          </video>
        </div>

        <div class="one-line"  v-show="mediaList[currentMediaIndex].mediaType === 'image'">
          <img :src="mediaList[currentMediaIndex].mediaSrc" style="width: 100%;">
        </div>-->

        <div class="dialog_main" >
          <!-- 跑马灯效果-->
          <van-swipe ref="mySwip" class="one-line custom-swipe" :show-indicators="true" indicator-color="#1edf41" @change="onSwipeChange" :loop="true">
            <van-swipe-item v-for="(media, index) in mediaList" :key="index"  style="position: relative;">
              <!--:poster="mediaList[1].mediaSrc"-->

              <div class="img_container">
<!--                <div v-show="showPoster" class="main-video poster-image" @click.self="videoClick('poster')"
                     :style="{backgroundImage: `url(${videoUrl}?x-oss-process=video/snapshot,t_1,m_fast,f_jpg)`,
                  }"
                />-->
                <div class="video_container" style="position: relative;">
                  <!--视频播放icon-->
                  <van-icon name="play-circle-o" size="64px" color="#8e867e" class="icon_play_video" v-if="media.mediaType === 'video' && !productPlaying"
                            @click.self="productVideoClick" />
<!--                   width="100%" height="100%" -->
                  <video id="myPDVideo" class="img_video" ref="productVideo"  v-if="media.mediaType === 'video'"
                         x5-video-orientation="portraint"
                         :controls="false"
                         preload="auto"
                         webkit-playsinline
                         x5-playsinline
                         playsinline="true"
                         :poster="mediaList[0].mediaSrc + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
                         :src="mediaList[0].mediaSrc"
                         @play="onProductVideoPlay"
                         @click.self="productVideoClick"
                         @ended="productPlaying = false"
                  ><!--  :class="{ 'rotate': needRotate }" @loadedmetadata="onLoadedmetadata"-->
                  </video>
                </div>


                <img class="img_video" v-lazy="media.mediaSrc" v-show="media.mediaType === 'image'" style="position: relative"/>
              </div>

            </van-swipe-item>
          </van-swipe>
        </div>


        <div class="pd_main">
          <div class="pd_box">
            <div class="pd_title" :class="{ 'custom_ellipsis': showEllipsis }" @click="pdNameClick">
              {{productItem.name}}
            </div>

            <div class="pd_info">
              <div class="pd_price">
                <span v-if="productItem.price !== ''"><span class="bi_span">￥</span>{{formatPrice(productItem.price)}}</span>
              </div>
              <div class="pd_fun">
                <!--  :icon="!adviceClickEnd? require('@/assets/img_loading.gif') : require('@/assets/img_loading_static.png')"-->
                <van-button class="pd_fun_select" type="primary" size="small" @click="clickAdvice(productItem.name)" iconPosition="left">
                  <div class="hx-flex-c-c" style="float: left" v-if="!adviceClickEnd && !expoundLoading">
                    <div class=" hx-flex-c-c">
                      <div class="play" :class="{ 'play1': !adviceClickEnd }"></div>
                      <div class="play " :class="{ 'play2': !adviceClickEnd }"></div>
                      <div class="play " :class="{ 'play3': !adviceClickEnd }"></div>
                      <div class="play " :class="{ 'play4': !adviceClickEnd }"></div>
                      <div class="play " :class="{ 'play5': !adviceClickEnd }"></div>
                    </div>
                  </div>
                  <van-loading size="12px" style="float: left" v-if="expoundLoading"/>
                  <span style="float: left;margin-left: 2px" v-if="adviceClickEnd && !expoundLoading"> 讲解 </span>
                </van-button>

                <van-button class="pd_fun_buy" type="primary" size="small" @click="jumpBuy(productItem)" v-if="false"> 立即下单 </van-button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </van-dialog>

    <van-action-sheet  v-model="showDialog" title="服务详情">
      <div class="product_nav">
<!--        <van-image :src="productItem.cover_urls[0]" mode="aspectFill" class="product_nav_image"></van-image>-->
        <img class="product_nav_image" v-lazy="productItem.cover_urls[0]" style="position: relative"/>
        <div class="product_nav_right">
          <div class="product_nav_name">{{productItem.name}}</div>
          <div class="product_nav_price">
            <div class="price_symbol">￥</div>
            <div class="price_value">{{productItem.price}}</div>
          </div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="line_bg">
        <div class="line_bg_inline">
        </div>
      </div>
      <div class="product_service_desc">
        <div class="product_desc_title">服务描述</div>
        <div class="product_desc product_desc_brief">{{productItem.comm_tip}}</div>
        <div class="product_desc">{{productItem.description}}</div>
      </div>

      <div class="line_container" style="position: relative;">
        <!--视频播放icon-->
        <van-icon name="play-circle-o" size="64px" color="#8e867e" class="icon_play_video" v-if="!productPlaying"
                  @click.self="productVideoClick" />
        <!--                   width="100%" height="100%" -->
        <video id="myPDVideo" class="img_video" ref="productVideo"  v-if="productItem.video_urls.length > 0"
               x5-video-orientation="portraint"
               :controls="false"
               preload="auto"
               webkit-playsinline
               x5-playsinline
               playsinline="true"
               :poster="mediaList[0].mediaSrc + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
               :src="productItem.video_urls[0]"
               @play="onProductVideoPlay"
               @click.self="productVideoClick"
               @ended="productPlaying = false"
        ><!--  :class="{ 'rotate': needRotate }" @loadedmetadata="onLoadedmetadata"-->
        </video>
      </div>
      <div class="line_container" style="position: relative;" v-for="(media, index) in productItem.cover_urls">
        <img class="img_video" v-lazy="media" style="position: relative" />
      </div>



    </van-action-sheet>
  </div>
</template>

<script>
import { SHOP_HOST } from '@/api/constants'
import { apiSendViewHistory } from '@/api/app'

export default {
  name: 'ProductDialog',
  components: {},
  props: {
    test: {
      type: Number,
      default: 3
    },
    productItem: {
      type: Object,
      default: {
        name: '',
        price: '',
        url: ''
      }
    },
    adviceClickEnd: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      touchStartX: 0,
      touchEndX: 0,
      currentMediaIndex: 0,
      currentPage: 1,
      showEllipsis: true,
      showDialog: true,
      showPoster: true,
      productPlaying: false,
      needRotate: false,
      expoundLoading: false
      /* mediaList: [
        {
          mediaType: 'video',
          mediaSrc: 'https://www.runoob.com/try/demo_source/mov_bbb.mp4'
        },
        {
          mediaType: 'image',
          mediaSrc: 'http://t13.baidu.com/it/u=1334881169,525968547&fm=224&app=112&f=JPEG?w=500&h=500'
        },
        {
          mediaType: 'image',
          mediaSrc: 'http://t15.baidu.com/it/u=1671880203,4256601092&fm=224&app=112&f=JPEG?w=500&h=500'
        },
        {
          mediaType: 'image',
          mediaSrc: 'https://img1.baidu.com/it/u=2622598109,2511427251&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=644'
        },{
          mediaType: 'image',
          mediaSrc: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fcbu01.alicdn.com%2Fimg%2Fibank%2F2020%2F252%2F396%2F15341693252_2043108825.jpg&refer=http%3A%2F%2Fcbu01.alicdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1712306315&t=0e50eb88f1577d585f876df83c074d12'
        },{
          mediaType: 'image',
          mediaSrc: 'https://img.zcool.cn/community/01a2336010be1d11013f7928ce4a91.jpg@1280w_1l_2o_100sh.jpg'
        },
      ], */
    }
  },
  computed: {
    currentMediaIndexPage(){
      return this.currentMediaIndex + 1
    },
    formatPrice() {
      return(price)=>{
        if (price === '' || typeof price === 'undefined'){
          return ''
        } else {
          let formattedPrice = parseFloat(price).toFixed(2)
          return formattedPrice
        }
      }

    },
    mediaList() {
      let resultList = []
      console.log('enter mediaList computed')
      this.productItem?.cover_urls.forEach(t=>{
        let mediaItem = {}
        mediaItem.mediaType = 'image'
        mediaItem.mediaSrc = t
        resultList.push(mediaItem)
      })
      if (this.productItem.video_urls &&  this.productItem?.video_urls.length > 0){
        let mediaItem = {}
        mediaItem.mediaType = 'video'
        mediaItem.mediaSrc = this.productItem.video_urls[0]
        resultList.unshift(mediaItem)
      }
      console.log('resultList', resultList)
      return resultList

    }
  },
  mounted () {
    console.log('productItem', this.productItem)
  },
  methods: {
    closeIconClick() {
      // 如果在播放产品视频先停止
      if (this.productPlaying){
        this.$refs.productVideo[0].pause()
        this.productPlaying = false
      }

      /* if (!this.adviceClickEnd){
        this.$emit('adviceClick', false)
      } */ // 注释后是关闭产品弹框后继续讲解逻辑
      this.$emit('onCloseMediaDialog', false)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentMediaIndex = val - 1
    },
    onSwipeChange(index) {
      console.log('onSwipeChange', index)
      this.currentMediaIndex = index

      if (index === 0){
        const video = this.$refs.productVideo[0]
        if (typeof video !== 'undefined' && video !== null){
          video.pause(); //视频暂停
          video.currentTime = 0; //时间归零
          console.log('视频二次访问时')
          video.load(); //视频二次访问时，封面加载不出来
        }
      } else {
        if (this.productPlaying){
          const video = this.$refs.productVideo[0]
          if (typeof video !== 'undefined' && video !== null){
            video.pause(); //视频暂停
          }
        }
      }
      this.productPlaying = false
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchMove(event) {
      this.touchEndX = event.touches[0].clientX;
    },
    handleTouchEnd() {
      const diff = this.touchEndX - this.touchStartX
      if (this.touchEndX !== 0 && this.touchStartX !== 0){
        if (diff > 50) {
          this.showPreviousImage();
        } else if (diff < -50) {
          this.showNextImage();
        }
      }

    },
    showPreviousImage() {
      console.log('showPreviousImage')
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex--
        this.currentPage--
      } else {
        this.$toast('已经是第一项了')
      }
    },
    showNextImage() {
      console.log('showNextImage')
      if (this.currentMediaIndex < this.mediaList.length - 1) {
        this.currentMediaIndex++
        this.currentPage++
      } else {
        this.$toast('已经是最后一项了')
      }
    },
    showProductDialog(item) {
      this.mediaDialog = true
      this.productItem = item
    },
    productVideoClick() {
      console.log('enter productVideoClick', this.$refs.productVideo)
      this.needRotate = !this.needRotate
      if (this.productPlaying){
        this.$refs.productVideo.pause() // [0]
        this.productPlaying = !this.productPlaying
      } else {
        setTimeout(()=>{
          this.$refs.productVideo.play() // [0]
        }, 200)
      }
    },
    onProductVideoPlay(){
      /* const video = this.$refs.productVideo[0];
      const mySwip = this.$refs.mySwip;
      console.log('video',video)
      console.log('mySwip',mySwip)
      const screenWidth = document.documentElement.clientWidth;
      console.log(`屏幕宽度是: ${screenWidth}px`);

      if (video) {
        const width = video.videoWidth; // 获取视频的宽度
        const height = video.videoHeight; // 获取视频的高度
        const pix = width / height
        const swipWidth = mySwip.offsetWidth

        console.log('video width ' , width, ' height:', height)
        console.log('video swipWidth ' , swipWidth)
        this.updateContainerDimensions(width, screenWidth, pix);
      } */
      this.needRotate = false
      this.productPlaying = true
      this.$emit('productVideoClick', 'productVideoClick')

      // this.currAudio.pause()
      // this.$refs.myVideo.pause()
      // this.showTalkVideo = false
    },
    updateContainerDimensions(width, height, pix) {
      // 更新包含视频的div容器的尺寸
      const container = this.$refs.productVideo[0]; // 假设你有一个ref指向div容器
      if (container) {
        container.style.width = `${height}px`; // 设置容器宽度
        //container.style.height = `${height}px`; // 设置容器高度
      }
    },
    pdVideoIsPlaying() {
      this.expoundLoading = false
      // const video = this.$refs.productVideo[0]
      const video = document.getElementById('myPDVideo');
      if (typeof video !== 'undefined' && video !== null){
        if (video.paused) {
          // console.log('视频已暂停');
          return false
        } else if (video.ended) {
          // console.log('视频已播放完成')
          return false
        } else {
          // console.log('视频正在播放');
          return true
        }
      }
      return false
    },
    setLoading(isLoading) {
      this.expoundLoading = isLoading
    },
    onLoadedmetadata(event){
      console.log('onLoadedmetadata event', event)
      const video = event.target
      console.log('Videoxxxx: ' , video);

      const clientWidth = video.clientWidth
      const clientHeight = video.clientHeight
      console.log('Video width: ' + video.videoWidth + ' pixels');
      console.log('Video height: ' + video.videoHeight + ' pixels');
      console.log('Video clientWidth: ' + clientWidth + ' pixels');
      console.log('Video clientHeight: ' + clientHeight + ' pixels');
      let diff = Math.abs(video.videoWidth / video.videoHeight -  video.clientWidth  / video.clientHeight);
      console.log('Video diff: ' + diff);
      if (diff < 0.2 ){
        console.log('被等比例了')
      } else {
        console.log('没被等比例了')
        // 获取屏幕宽度 等比列重设视频的高宽
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;

        console.log("Viewport width: " + viewportWidth);
        console.log("Viewport height: " + viewportHeight);
        var newWidth = clientHeight
        this.needRotate = true

        const video2 = document.getElementById('myPDVideo');
        if (typeof video2 !== 'undefined' && video2 !== null){
          video2.height = newWidth
        }

      }

    },
    isWebURL2(str) {
      // 定义网址的正则表达式
      // const urlPattern = /^(https?:\/\/|www\.)\S+/i;
      /* const urlPattern = /^(https?:\/\/|www\.)\S+(?<!\.mp4|\.jpg|\.jpeg|\.png)$/i;
      // 使用正则表达式进行匹配
      return urlPattern.test(str); */
      return true
    },
    isWebURL(str) {
      // 定义网址的正则表达式
      const urlPattern = /^(https?:\/\/|www\.)\S+/i
      // 使用正则表达式进行匹配
      return urlPattern.test(str);
    },
    isDomainURL(url){
      const specifiedDomain = 'h5.meuagi.com'

      // 正则表达式，用于匹配指定域名
      const regex = new RegExp(`^https?:\/\/${specifiedDomain}`, 'i')

      // 检查链接是否符合指定的域名
      if (regex.test(url)) {
        console.log('链接符合指定的域名规则');
        return true
      } else {
        console.log('链接不符合指定的域名规则');
        return false
      }
    },
    jumpBuy(item) {
      // console.log('jumpBuy item', item)
      let url = item.url

      // 加入商城体系后 url需要预处理
      // 如果商品id不为空 则拼接商城id
      if (typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== ''){
        url = SHOP_HOST + item.mall_commodity_id
      }

      if (typeof url === 'undefined' || url === '') {
        this.$myToast({
          type: "fail",
          message: "无商品链接",
        })
        return
      }
      if (!this.isWebURL(url)){
        this.$myToast({
          type: "fail",
          message: "无效商品链接",
        })
        return
      }
      // 非我们的商城网址的，一律进行限制和提示
      // if (!this.isDomainURL(url)){
      //   this.$myToast({
      //     type: "fail",
      //     message: "无效商品链接",
      //   })
      //   return
      // }

      // this.$router.push(`/external-link/${encodeURIComponent(url)}`) // 'https://h5.meuagi.com/package-prod/pages/prod/prod?prodId=5'
      if (window !== window.top){
        // 页面在一个 <iframe> 中加载
        // 打开一个新窗口
        console.log('页面在一个iframe中加载 打开一个新窗口')
        let newWindow = window.open('', '_blank')
        // 调整新窗口的链接
        newWindow.location.href = url
      } else {
        // 页面在顶层窗口中加载
        console.log('页面在顶层窗口中加载')

        if (this.$store.state?.appletInfo?.shop_token !== '') {
          console.log('shop_token', this.$store.state?.appletInfo?.shop_token)
          url = url + '&shop_token=' + this.$store.state?.appletInfo?.shop_token
        } else {
          this.$myToast({
            type: "fail",
            message: "无有效商城凭据，请重新登录小程序再试",
          })
          return
        }
        let link = document.createElement("a");
        link.href = url;

        link.target = "_self" // _self _blank// 设置属性为'_self'，在当前标签页打开链接
        const originPhone = this.$store.state?.vuex_app_user_info?.phone || ''
        // 如果是H5 则打开新的窗口
        if (!this.$store.state.weiXinMark) {
          link.target = "_blank"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          let userAgent = navigator.userAgent.toLowerCase()
          if (userAgent.indexOf('miniprogram') !== -1) {
            console.log('在微信小程序中打开的webview')
            // 如果是有商品id 则跳转小程序订单详情页面
            if (typeof item.mall_commodity_id !== 'undefined' && item.mall_commodity_id !== '') {
              // 停止播报 @todo
              // 跳转到微信小程序A中的某个页面并携带参数
              wx.miniProgram.navigateTo({
                url: '/package-prod/pages/prod/prod?prodId=' + item.mall_commodity_id + '&originPhone=' + originPhone
              })
            } else {
              console.log('没有商品id 则正常跳转其他网页')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }

          } else {
            console.log('在浏览器中打开的网页')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      }
    },
    clickAdvice(name) {
      // 点击后发送prompt消息:
      // 请以第一人称视角简单介绍一下{{产品名称}}的卖点和活动。
      // 如果在播放产品视频先停止
      if (this.productPlaying){
        this.$refs.productVideo[0].pause()
        this.expoundLoading = false
        this.productPlaying = false
      }

      if (this.adviceClickEnd){
        this.productPlaying = false
        this.$emit('adviceClick',true)
        let promptStr = '请以第一人称视角简单介绍一下产品名称:' + name + ',的卖点和活动,介绍的字数限制在100字内。'
        if (name === ''){
          promptStr = '请以第一人称视角简单介绍一下我们的产品的卖点和活动,介绍的字数限制在100字内。'
        }

        console.log('promptStr:', promptStr)
        this.expoundLoading = true
        this.$emit('promptMessage', promptStr)
      } else {
        this.expoundLoading = false
        this.$emit('adviceClick', false) // 没结束讲解，就中断讲解
      }

    },
    pdNameClick() {
      this.showEllipsis = false
    }
  }
}
</script>

<style lang="less" scoped>


.custom-media-dialog-width {
  // 小于450宽度的移动端
  @media (max-width: 350px) {
    width: 100vw;
  }
  @media (min-width: 451px) {
    width: var(--app-max-width);
  }

}
.custom-media-dialog{
  height: 100vh;
  @media (max-width: 450px) {
    /*background-color: lightcoral; 在屏幕宽度小于450px时应用的样式A */
    width: 100vw !important;
  }
  margin-top: 0;
  top: 50%;
  background: none;
  display: flex;
  align-items: center;
  border-radius: 0;
  .media-main{
    color: #000;
    height: 100vh;
    background: rgb(50, 56, 52);
    //max-width: var(--app-max-width);
    position: relative;

    .dialog_title_dark{
      position: absolute;
      top: 25px;
      float: left;
      width: 100%;
      height: 40px;
      line-height: 1;
      text-align: center;
      color: white;
      padding:0 25px 0 15px;
      box-sizing: border-box;
      z-index: 9;
      .title_content{
        width: 100%;
        height: 100%;
        text-align: center;
        letter-spacing: normal;
        padding-right: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ADADAD ; /* 设置文字颜色 */
        -webkit-text-stroke: 0.2px black; /* 描边效果，1px 为描边宽度，black 为描边颜色 */
        text-stroke: 0.2px black; /* 标准语法 */
        font-weight: bolder;
      }
    }

    .dialog_main{
      float: left;
      width:100%;
      height: 100vh;
      display: flex;
      align-items: center;

    }

    .one-line{
      width: 100%;
      height: 100%;
      float: left;
    }
    .pd_main{
      padding: 0 20px;
      position: absolute;
      bottom: 60px;
      width: 100%;
      min-height: 86px;
      z-index: 9;
      .pd_box{
        width: calc(100% - 40px);
        min-height: 86px;
        background-image: url('~@/assets/mao.png');
        background-size: 100% 100%;
        background-repeat: no-repeat; /* 防止背景图片重复 */
        backdrop-filter: blur(5px); // 毛玻璃效果
      }
    }
    .pd_title{
      float: left;
      width: 100%;
      min-height: 24px;
      line-height: 24px;
      color: white;
      font-size: 18px;
      padding-left: 15px;
      margin: 5px 0;
      box-sizing: border-box;

    }
    .custom_ellipsis{
      //超出后省略号
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .pd_info{
      float: left;
      width: 100%;
      height: 36px;
      line-height: 36px;
      color: white;
      font-size: 18px;
      padding-left: 15px;
      box-sizing: border-box;
      .pd_price{
        min-width: 60px;
        float: left;
        height: 36px;
        line-height: 36px;
        font-size: 18px;
        font-family: fangsong;
        .bi_span{
          font-size: 15px;
          margin-right: 2px;
        }
      }
      .pd_fun{
        float: right;
        width: 190px;
        text-align: right;
        padding-right: 15px;
        .pd_fun_select{
          width: 70px;
          border: 0;
          background: rgba(68, 71, 70, 1);
          color: #1edf41;
          border-radius: 5px;
          .van-button__text{
            display: flex;
          }
        }
        .pd_fun_buy{
          width: 70px;
          border: 0;
          border-radius: 5px;
          background: rgba(252, 102, 2, 1);
          color: white;
          margin-left: 15px;
        }
      }
    }
  }
}
.product_nav{
  float: left;
  position: relative;
  width: 100%;
  height: 97px;
  margin-bottom: 18px;
  display: flex; /* 使用flex布局 */
  align-items: center; /* 垂直居中 */
  box-sizing: border-box;
  padding: 0 14px;
  .img_video {
    // 图片也要限定高宽
    width: 100%;
    /*max-width: 100%;  设置最大宽度为100% */
    //height: auto;
    display: block;
    //object-fit: cover;//让封面图撑满整个视频，还想让封面图不被挤压变形。
  }
  .product_nav_image{
    float: left;
    width: 97px;
    height: 97px;
    margin-right: 12px;
    border-radius: 8px !important;
  }

  .product_nav_right{
    float: left;
    display: flex;
    flex: 1; /* 占据剩余空间 */
    flex-direction: column; /* 上下排列 */
    justify-content: space-between; /* 上下内容分散对齐 */
    height: 100%; /* 高度与父容器一致 */
    box-sizing: border-box;
    padding-top: 10rpx;
  }
  .product_nav_name{
    float: left;
    width: 100%;
    font-size: 16px;
    color: #333;
    font-family: PingFangSC, PingFang SC;
    font-weight: 550;
    color: #000000;
    line-height: 38rpx;
    text-align: left;
    font-style: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  /* 价格符号 */
  .price_symbol {
    float: left;
    font-size: 11px;
    color: #ff8c00;
    transform: translateX(10%);
  }

  /* 价格数值 */
  .price_value {
    font-size: 16px;
    color: #ff8c00;
    font-weight: bold;
  }
  .product_nav_price{
    float: left;
    width: 100%;
    height: 22px;
  }
}

.line_bg{
  float: left;
  height: 2px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 14px;
  margin-bottom: 14px;
  .line_bg_inline{
    width: 100%;
    height: 100%;
    background: #e3e6ec;
    border-radius: 14px;
  }
}

.product_service_desc{
  float: left;
  width: 100%;
  margin-bottom: 20px;
  padding: 0 14px;
  box-sizing: border-box;
  .product_desc_title{
    float: left;
    width: 100%;
    height: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 550;
    font-size: 14rpx;
    color: #000000;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin-bottom: 2px;
  }

  .product_desc{
    float: left;
    width: 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    line-height: 1.5;
  }
}

.line_container{
  position: relative;
  width: 100%;
  //max-height: 100vh; /* 设置容器固定高度 */
  float: left;
  overflow: auto; /* 或者使用 overflow: scroll; */
  padding: 0 14px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .icon_play_video{
    position: absolute;
    left: 50%;
    top: 50%;
    opacity: 0.5;
    transform: translate(-50%, -50%);
  }
  .img_video {
    // 图片也要限定高宽
    width: 100%;
    /*max-width: 100%;  设置最大宽度为100% */
    //height: auto;
    display: block;
    //object-fit: cover;//让封面图撑满整个视频，还想让封面图不被挤压变形。
  }
}
.line_container:last-child{
  margin-bottom: 2px !important;
}
</style>

<style lang="less">
.custom-media-dialog{
  .van-dialog__content{
    width: 100%;
  }
}
.custom-swipe{
  .van-swipe__indicators{
    left: calc(50vw);
  }
  //不加会导致图片index文字被挤压到不显示
  .van-swipe__track{
    width: 100vw;
  }

  .img_container{
    width: 100%;
    //max-height: 100vh; /* 设置容器固定高度 */
    height: 100%;
    overflow: auto; /* 或者使用 overflow: scroll; */
    display: flex;
    align-items: center;

    .img_video {
      // 图片也要限定高宽
      width: 100%;
      /*max-width: 100%;  设置最大宽度为100% */
      //height: auto;
      display: block;
      //object-fit: cover;//让封面图撑满整个视频，还想让封面图不被挤压变形。


    }
  }
  .icon_play_video{
    position: absolute;
    left: 50%;
    top: 50%;
    opacity: 0.5;
    transform: translate(-50%, -50%);
  }
}
.rotate{
  transform: rotate(90deg);
}
</style>

<style lang="less" scoped>
.loading_div{
  height: 100%;
}
.voice-playing {
  transform: scale(0.8);
}
@play-h: 6px;

.play {
  width: 2px;
  margin-left: 2px;
  height: @play-h;
  border-radius: 2px;
  background-color: #1edf41;
}
.play1 {
  animation: playing 0.5s linear infinite alternate;
}
.play2 {
  animation: playing 0.5s 0.2s linear infinite alternate;
}
.play3 {
  animation: playing 0.5s 0.4s linear infinite alternate;
}
.play4 {
  animation: playing 0.5s 0.6s linear infinite alternate;
}
.play5 {
  animation: playing 0.5s 0.8s linear infinite alternate;
}
@keyframes playing {
  0% {
    transform: scaleY(0.5);
  }
  100% {
    transform: scaleY(2);
  }
}

.main-video {
  /*width: 100%;
  height: calc(100vh - 64px);
  min-width: 100%;
  min-height: calc(100vh - 64px);*/
  margin: 0;
  padding: 0;
  border: none;
  object-fit: cover;
}
.videoTest{
  transform: translateZ(0);
}
/* This used to work for the parent element of button divs */
/* But it does not work with newer browsers, the below doesn't hide the play button parent div */


.main-video::-webkit-media-controls-panel {
  display: none !important;
  -webkit-appearance: none;
}

/* Old shadow dom for play button */

.main-video::-webkit-media-controls-play-button {
  display: none !important;
  -webkit-appearance: none;
}

/* New shadow dom for play button */

/* This one works! */

.main-video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

.IIV::-webkit-media-controls-play-button,
.IIV::-webkit-media-controls-start-playback-button,
.main-video::-webkit-media-controls-play-button,
.main-video::-webkit-media-controls-start-playback-button {
  opacity: 0;
  pointer-events: none;
  width: 5px;
}
</style>
